export default __webpack_public_path__ + "static/media/card-it-telecom.2c5b224a.png";